import Button from "components/atoms/buttons/Button";
import { CloseIcon } from "components/atoms/Icon";
import Modal from "components/atoms/modal";

type Props = {
  onModalClose: () => void;
  handleContinueButtonClick: () => void;
};

function FormExitConfirmationModal({ onModalClose, handleContinueButtonClick }: Props) {
  return (
    <Modal open onClose={onModalClose}>
      <div className=" rounded-2xl bg-primary p-7  shadow-modal 2xl:w-[558px]">
        <div className="flex justify-between">
          <div className="w-8/12">
            <section className="w-full font-satoshi text-2xl font-bold leading-9 text-white">
              Are you sure you want to go back?
            </section>
            <section className="mt-3 w-full font-satoshi text-sm font-450 text-white">
              All your saved progress will be lost once you go back and cannot be retrieved.
            </section>
          </div>
          <div>
            <button
              type="button"
              onClick={onModalClose}
              className="cursor-pointer rounded-lg border border-black border-opacity-10 p-3"
            >
              <CloseIcon className="h-4 w-4 text-white" />
            </button>
          </div>
        </div>

        <div className="mt-16 flex justify-end gap-3">
          <Button
            variant="whiteOutline"
            text="CANCEL"
            onClick={onModalClose}
            additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
          />
          <Button
            variant="magnetiqSolid"
            text="CONTINUE"
            onClick={handleContinueButtonClick}
            additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
          />
        </div>
      </div>
    </Modal>
  );
}
export default FormExitConfirmationModal;
